import React from 'react'
import {
  type StudentProjectReport,
  type StudentSystemType
} from '../../students/types/types'
import { useGetLeaderBoardQuery } from '../api/leaderBoardApi'
import LeaderBoardPresentation from '../presentation/LeaderBoardPresentation'
interface LeaderBoardContainerProps {
  account: StudentSystemType
  projectReport: StudentProjectReport
}
const LeaderBoardContainer: React.FC<LeaderBoardContainerProps> = ({
  account,
  projectReport
}) => {
  const {
    data: leaderBoards,
   
    isSuccess,
  } = useGetLeaderBoardQuery(JSON.stringify(account));
  return (
    <>{isSuccess && <LeaderBoardPresentation leaderBoard={leaderBoards} />}</>
  )
}

export default LeaderBoardContainer
